export class MvNotFoundPage extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback(): void {
    this.render();
  }

  private render(): void {
    if (!this.shadowRoot) {
      return;
    }

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }

        article {
          padding: 28px;
          border-radius: 28px;
          border: 1px solid rgba(49, 70, 61, 0.14);
          background: rgba(250, 247, 241, 0.9);
          box-shadow: 0 18px 38px rgba(31, 42, 35, 0.08);
        }

        p {
          margin: 0;
          text-transform: uppercase;
          letter-spacing: 0.14em;
          font-size: 0.75rem;
          color: #5e6f62;
        }

        h1 {
          margin: 12px 0 0;
          color: #31463d;
          font-family: 'Palatino Linotype', 'Book Antiqua', serif;
          font-size: clamp(2rem, 5vw, 3rem);
        }

        a {
          display: inline-flex;
          margin-top: 20px;
          padding: 12px 16px;
          border-radius: 999px;
          background: #31463d;
          color: #f7f3ed;
          text-decoration: none;
        }
      </style>

      <article>
        <p>Fallback del router</p>
        <h1>Ruta no disponible</h1>
        <a href="/">Volver a la base del proyecto</a>
      </article>
    `;
  }
}

if (!customElements.get('mv-not-found-page')) {
  customElements.define('mv-not-found-page', MvNotFoundPage);
}
